import { styled, Box } from '@withjoy/joykit';

// Edge fade is applied to the slick viewport only, so the arrow discs (siblings,
// positioned above) stay fully opaque.
export const CarouselWrapper = styled(Box)`
  position: relative;
  width: 100%;

  .slick-list {
    -webkit-mask-image: linear-gradient(to right, transparent 0%, #000 12%, #000 88%, transparent 100%);
    mask-image: linear-gradient(to right, transparent 0%, #000 12%, #000 88%, transparent 100%);
  }

  /* react-slick wraps each child in a div; pad that for the inter-thumb gutter
     without fighting slick's inline slide-width calc. */
  .slick-slide > div {
    padding: 0 5px;
  }
`;

export const Thumb = styled.button<{ $selected: boolean }>`
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background-color: ${props => props.theme.colors.mono2};
  border: 2px solid ${({ $selected, theme }) => ($selected ? theme.colors.mono14 : 'transparent')};
  transition: border-color ease-in-out 0.15s;

  // Selected keeps its black ring; unselected thumbs use brand-primary blue for
  // hover and the darker pressed blue for press.
  &:hover {
    border-color: ${({ $selected, theme }) => ($selected ? theme.colors.mono14 : theme.colors.newUIBrandPrimary)};
  }

  &:active {
    border-color: ${({ $selected, theme }) => ($selected ? theme.colors.mono14 : theme.colors.buttonPrimaryActive)};
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ArrowButton = styled.button<{ $side: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  ${({ $side }) => ($side === 'left' ? 'left: 0;' : 'right: 0;')}
  transform: translateY(-50%);
  z-index: 2;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background-color: ${props => props.theme.colors.white};
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  opacity: 0;
  transition: opacity ease-in-out 0.15s;

  svg {
    ${({ $side }) => ($side === 'right' ? 'transform: rotate(180deg);' : '')}
  }

  &:hover,
  &:focus-visible {
    opacity: 1;
  }

  ${CarouselWrapper}:hover & {
    opacity: 1;
  }
`;
